import axios from 'axios';
import get from 'lodash/get';

import { AdTechGlobal, EnvironmentName } from '@wetransfer/ad-sdk';

import {
  WT_AD_WALLPAPER_INITIALIZED,
  WT_AD_WALLPAPER_LOADED,
} from '../constants';
import request from '@wetransfer/transfer/modules/http/axios/request';
import { isBetaEnv, isLocalEnv } from '@wetransfer/transfer/modules/url';

export const createLocalUrl = async (
  url: string
): Promise<{ localUrl: string; cleanup: () => void }> => {
  const result = await axios.get(url, { responseType: 'blob' });

  const localUrl = URL.createObjectURL(result.data);

  return { localUrl, cleanup: () => URL.revokeObjectURL(localUrl) };
};

export const getManifestEntryPoint = async (
  manifestUrl: string
): Promise<string> => {
  const payload = await request({
    path: `${manifestUrl}?cache-bust=${Math.random()}`, //force skip browser cache
  });

  const manifest: {
    entrypoints: string[];
  } = payload.body;
  const { entrypoints } = manifest;

  const [main] = entrypoints;

  return main;
};

export const getHost = (): string => {
  return `${get(
    window,
    '__wallpaper_bundle__.microFrontendHost',
    'https://nolan.wetransfer.net/apps/wallpaper'
  )}`;
};

export const getWallpaper = (): undefined | AdTechGlobal['wallpaper'] => {
  return window.AdTech?.wallpaper;
};

export const emitWallpaperLoaded = (): void => {
  window.dispatchEvent(new Event(WT_AD_WALLPAPER_LOADED));
};

export const emitWallpaperInitialized = (): void => {
  window.dispatchEvent(new Event(WT_AD_WALLPAPER_INITIALIZED));
};

export const getEnv = (): EnvironmentName => {
  if (isLocalEnv()) {
    // We want to continue to serve ads for all the teams working on Transfer
    return EnvironmentName.Production;
  }

  if (isBetaEnv()) {
    return EnvironmentName.Staging;
  }

  return EnvironmentName.Production;
};
